'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoldenB = exports.GoldenA = exports.Quarter = exports.Third = exports.Half = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: ', ';\n  padding-left: ', 'px;\n  padding-right: ', 'px;\n  width: 100%;\n  ', '\n  ', ' {\n    ', '\n  }\n  ', ' {\n    ', '\n  }\n  ', ' {\n    ', '\n  }\n'], ['\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: ', ';\n  padding-left: ', 'px;\n  padding-right: ', 'px;\n  width: 100%;\n  ', '\n  ', ' {\n    ', '\n  }\n  ', ' {\n    ', '\n  }\n  ', ' {\n    ', '\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var breakpoints = {
  small: '40em',
  medium: '52em',
  large: '64em'
};

var ms = function ms(size) {
  return '@media screen and (min-width: ' + size + ')';
};
var mx = function mx(point) {
  return function (props) {
    return _typeof(props.theme.breakpoints) === 'object' ? ms(props.theme.breakpoints[point]) : ms(breakpoints[point]);
  };
};

var pad = function pad(props) {
  return typeof props.theme.gutter === 'number' ? props.theme.gutter : 32;
};

var p = function p(n) {
  return typeof n !== 'undefined' ? n * 100 + '%' : null;
};

var width = function width(key) {
  return function (props) {
    return props[key] ? 'width: ' + p(props[key]) + ';' : null;
  };
};

var align = function align(props) {
  return props.align || 'top';
};

var Grid = (0, _styledComponents2.default)('div')(_templateObject, align, pad, pad, width('xs'), mx('small'), width('sm'), mx('medium'), width('md'), mx('large'), width('lg'));

var Half = exports.Half = function Half(props) {
  return _react2.default.createElement(Grid, _extends({}, props, { sm: 1 / 2 }));
};
var Third = exports.Third = function Third(props) {
  return _react2.default.createElement(Grid, _extends({}, props, { sm: 1 / 3 }));
};
var Quarter = exports.Quarter = function Quarter(props) {
  return _react2.default.createElement(Grid, _extends({}, props, { md: 1 / 4 }));
};

var φ = (1 + Math.sqrt(5)) / 2;
var ga = φ - 1;
var gb = 1 - ga;

var GoldenA = exports.GoldenA = function GoldenA(props) {
  return _react2.default.createElement(Grid, _extends({}, props, { sm: ga }));
};
var GoldenB = exports.GoldenB = function GoldenB(props) {
  return _react2.default.createElement(Grid, _extends({}, props, { sm: gb }));
};

exports.default = Grid;


//////////////////
// WEBPACK FOOTER
// ./~/grid-styled/dist/Grid.js
// module id = 260
// module chunks = 0